import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  tableContainer: {
    maxHeight: 'calc(100vh - 235px)',
    borderTop: '3px solid #DF0C36',
  },
  stickyHeader: {
    backgroundColor: '#fcfcfc',
  },
  table: {
    minWidth: 750,
    borderCollapse: 'unset',
  },
  tableHead: {
    height: '40px',
    fontSize: '14px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: '#666666',
    padding: '0px 25px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    lineHeight: '18px',
  },
  filterListIcon: {
    color: '#DF0C36',
    position: 'absolute',
    height: 18,
    width: 18,
    marginBottom: '5.5%',
    bottom: 0,
    right: 0,
    top: 15,
    marginRight: '2%',
  },
  expandMoreIcon: {
    color: '#ffffff',
    '&:hover': {
      color: '#666666',
    },
    position: 'absolute',
    height: 18,
    width: 18,
    marginBottom: '5.5%',
    bottom: 0,
    right: 0,
    top: 15,
    marginRight: '2%',
  },
  arrow: {
    color: '#DF0C36',
    height: 18,
    width: 18,
    marginBottom: '5.5%',
    bottom: 0,
    top: 5,
    marginRight: '2%',
  },
  paperPopper: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    width: 200,
  },
  container: {
    height: 40,
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
  },
  filterIcon: {
    color: '#DF0C36 !important',
    marginLeft: 28,
    marginRight: 18,
  },
  autoCompleteTextBox: {
    maxHeight: 200,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  filterText: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#666666',
  },
  tag: {
    backgroundColor: '#DF0C36',
    position: 'relative',
    zIndex: 0,
    '& .MuiChip-label': {
      color: '#fff',
    },
    '& .MuiChip-deleteIcon': {
      color: '#fff',
    },
  },
  tableCell: {
    fontSize: '12px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    borderWidth: 1,
    color: '#666666',
    whiteSpace: 'nowrap',
    padding: '12px 10px',
    lineHeight: '18px',
  },
  siteConcerned: { textTransform: 'capitalize' },
  row: {
    cursor: 'pointer',
  },
  selectIcon: {
    color: '#DF0C36',
  },
  actions: {
    color: '#DF0C36',
  },
  paginationBox: {
    borderTop: '1px solid #e5e5e5',
  },
  multiSelectOption: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '16px',
    color: '#666666',
    textTransform: 'capitalize',
  },
  root: {
    '&$checked': {
      color: '#DF0C36',
    },
  },
  checked: {},
  listBox: {
    width: 200,
    margin: '2px 0 0',
    padding: 0,
    position: 'absolute',
    listStyle: 'none',
    backgroundColor: '#fff',
    overflow: 'auto',
    maxHeight: 250,
    borderRadius: 4,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    zIndex: 1,
  },
  errorIcon: {
    marginLeft: '20px',
    color: '#E74C3C',
  },
}));
